import React from 'react';
import { useRefinementList } from 'react-instantsearch';
import PropTypes from 'prop-types';

const classnames = require('classnames');

const parseRefinementOptions = items => {
    const options = [];

    items.forEach(item => {
        const { label } = item;

        if (label.includes(' > ')) {
            return;
        }

        options.push({
            ...item,
            children: [],
        });
    });

    items.forEach(item => {
        const { label } = item;

        if (!label.includes(' > ')) {
            return;
        }

        const labelParsed = label.split(' > ');
        const parentIndex = options.findIndex(option => option.label === labelParsed[0]);

        if (parentIndex < 0) {
            return;
        }

        options[parentIndex].children.push(item);
    });

    return options;
};

export const HierarchicalMenuMulti = props => {
    const { items, refine } = useRefinementList(props);
    const filterOptions = parseRefinementOptions(items);

    return (
        <div className="ais-HierarchicalMenu">
            <ul className="ais-HierarchicalMenu-list">
                {filterOptions.map(filterOption => {
                    const parentClasses = classnames('ais-HierarchicalMenu-item', {
                        'ais-HierarchicalMenu-item--selected ais-HierarchicalMenu-item--parent': filterOption.isRefined,
                    });

                    return (
                        <li key={filterOption.label} className={parentClasses}>
                            <div className="ais-HierarchicalMenu-item-content">
                                {/* Parent checkbox - handle independently */}
                                <span className="ais-HierarchicalMenu-checkbox">
                                    <label className="mb-0">
                                        <input
                                            type="checkbox"
                                            checked={filterOption.isRefined}
                                            onChange={() => {
                                                refine(filterOption.value);

                                                // Untoggle any checked child items
                                                filterOption.children.forEach(child => {
                                                    if (child.isRefined) {
                                                        refine(child.value);
                                                    }
                                                });
                                            }}
                                        />
                                        <span className="ais-HierarchicalMenu-link">
                                            <span className="ais-HierarchicalMenu-label">{filterOption.label}</span>{' '}
                                            <span className="ais-HierarchicalMenu-count">{filterOption.count}</span>
                                        </span>
                                    </label>
                                </span>
                            </div>

                            {/* Child items */}
                            {filterOption.children.length > 0 && (
                                <ul
                                    className="ais-HierarchicalMenu-list ais-HierarchicalMenu-list--child"
                                    style={{
                                        display:
                                            filterOption.isRefined ||
                                            filterOption.children.find(child => child.isRefined)
                                                ? 'block'
                                                : 'none',
                                    }}
                                >
                                    {filterOption.children.map(filterOptionChild => {
                                        const childClasses = classnames('ais-HierarchicalMenu-item', {
                                            'ais-HierarchicalMenu-item--selected': filterOptionChild.isRefined,
                                        });

                                        const childLabelCode = filterOptionChild.label.split(' > ')[1];
                                        const childLabelParts = childLabelCode.split('-');
                                        const childLabel =
                                            childLabelParts.length > 0 ? childLabelParts[1] : childLabelParts[0];

                                        return (
                                            <li key={filterOptionChild.label} className={childClasses}>
                                                <div className="ais-HierarchicalMenu-item-content">
                                                    {/* Child checkbox - handle independently */}
                                                    <span className="ais-HierarchicalMenu-checkbox">
                                                        <label className="mb-0">
                                                            <input
                                                                type="checkbox"
                                                                checked={filterOptionChild.isRefined}
                                                                onChange={() => {
                                                                    // Refine child and unrefine parent
                                                                    refine(filterOptionChild.value);

                                                                    if (filterOption.isRefined) {
                                                                        refine(filterOption.value);
                                                                    }
                                                                }}
                                                            />

                                                            <span className="ais-HierarchicalMenu-link">
                                                                <span className="ais-HierarchicalMenu-label">
                                                                    {childLabel}
                                                                </span>{' '}
                                                                <span className="ais-HierarchicalMenu-count">
                                                                    {filterOptionChild.count}
                                                                </span>
                                                            </span>
                                                        </label>
                                                    </span>
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            )}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};
